import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import styles from './FJMobileTextToImageEdit.module.less';
import PropTypes from 'prop-types';
import FJMobileTextToImageInputContainer from '../FJMobileTextToImageInput/FJMobileTextToImageInputContainer';
import FJMobileTextToImageEditFooterContainer from '../FJMobileTextToImageEditFooter/FJMobileTextToImageEditFooterContainer';

const FJMobileTextToImageEdit = props => {
    const { generate, taskStatus, freeNumCreation, isProjectLoading, useCredit, creditNumber } = props;

    const isFree = freeNumCreation > 0 && useCredit > creditNumber;
    return (
        <div className={styles.container}>
            <FJMobileTextToImageInputContainer />
            <FJMobileTextToImageEditFooterContainer />
            <div className={styles.btn_box}>
                <FJGenerateButton
                    onClick={generate}
                    taskStatus={taskStatus}
                    isFree={isFree}
                    freeNumCreation={freeNumCreation}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                    className={styles.btn}
                />
            </div>
        </div>
    );
};
FJMobileTextToImageEdit.propTypes = {
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    useCredit: PropTypes.number,
    generate: PropTypes.func,
    isProjectLoading: PropTypes.bool,
};
export default FJMobileTextToImageEdit;
